// extracted by mini-css-extract-plugin
export default {"pageLoader":"pageLoader_pageLoader__wJicz","image":"pageLoader_image__ID7gG","logo":"pageLoader_logo__ae-E7"};